import { render, staticRenderFns } from "./waiterApply.vue?vue&type=template&id=6fd758c6&scoped=true&"
import script from "./waiterApply.vue?vue&type=script&lang=js&"
export * from "./waiterApply.vue?vue&type=script&lang=js&"
import style0 from "./waiterApply.vue?vue&type=style&index=0&id=6fd758c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd758c6",
  null
  
)

export default component.exports